<template>
  <v-container-principal>
    <div class="font-weight-black primary--text text-h5 mb-3">
      <v-btn :icon="true" :to="{ name: 'blocos' }">
        <v-icon class="text-h4" color="black">$prev</v-icon>
      </v-btn>
      {{ id ? "Editar Bloco" : "Criar Bloco" }}
    </div>

    <ValidationObserver ref="obs" v-slot="{ invalid }">
      <v-form>
        <div class="pt-5">
          <v-row>
            <v-col cols="4">
              <ValidationProvider
                name="Name"
                rules="required"
                v-slot="{ errors, valid }">
                <v-text-field
                  class="rounded-lg"
                  placeholder="Informe o nome do bloco"
                  label="Nome do bloco"
                  outlined
                  dense
                  v-model="bloco.descricao"
                  :error-messages="errors"
                  :success="valid" />
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <ValidationProvider
                name="Name"
                rules="required|min_andar:1"
                v-slot="{ errors, valid }">
                <v-text-field
                  class="rounded-lg"
                  min="1"
                  type="number"
                  label="Número de pisos do bloco"
                  outlined
                  dense
                  v-model="bloco.quantidadeAndar"
                  :error-messages="errors"
                  :success="valid" />
              </ValidationProvider>
            </v-col>
          </v-row>
        </div>

        <v-row>
          <v-col md-6>
            <v-btn outlined x-large color="primary" to="/blocos" class="mr-3">
              Cancelar</v-btn
            >
            <v-btn
              @click.prevent="salvarBloco"
              class="text-capitalize"
              depressed
              x-large
              :disabled="invalid"
              color="primary">
              Salvar informações
            </v-btn>
          </v-col>
          <v-col v-if="id" md-6>
            <v-row justify="end">
              <v-btn
                @click.prevent="dialogDelete = true"
                x-large
                plain
                color="red"
                class="my-3">
                Excluir Bloco</v-btn
              >
            </v-row>
          </v-col>
        </v-row>
      </v-form>
    </ValidationObserver>
  </v-container-principal>
</template>

<script>
import { RepositoryFactory } from "../../repositories/repositoryFactory"
import { ValidationObserver, ValidationProvider } from "vee-validate"
import VContainerPrincipal from "../../components/VContainerPrincipal"
import { mapActions } from "vuex"

const blocoRepository = RepositoryFactory.get("bloco")

const BLOCO_CRIADO_COM_SUCESSO = "Bloco criado com sucesso!"
const BLOCO_ALTERADO_COM_SUCESSO = "As alterações foram salvas com sucesso!"
const ERRO_SALVAR = "Erro ao salvar informações."
const PREENCHA_CAMPOS = "Preencha todos os campos."
const MIN_ANDAR = "O número de pisos deve ser no mínimo 1."

export default {
  components: { ValidationObserver, ValidationProvider, VContainerPrincipal },
  props: ["id"],
  data: () => ({
    bloco: {
      descricao: "",
      quantidadeAndar: "",
    },
  }),
  created() {
    if (this.id) {
      blocoRepository.getOne(this.id).then((response) => {
        this.bloco.descricao = response.data.data.attributes.descricao
        this.bloco.quantidadeAndar =
          response.data.data.attributes.quantidadeAndar
      })
    }
  },
  methods: {
    salvarBloco() {
      if (this.isBlocoValido()) {
        const payload = { data: this.bloco }

        const repositoryPromise = this.id
          ? blocoRepository.update(this.id, payload)
          : blocoRepository.create(payload)

        repositoryPromise
          .then((res) => {
            if (res.status === 200) {
              const sucessoMensagem = this.id
                ? BLOCO_ALTERADO_COM_SUCESSO
                : BLOCO_CRIADO_COM_SUCESSO

              this.showSucesso(sucessoMensagem)

              if (!this.id) {
                this.$router.push("/blocos")
              }
            } else {
              this.showErro(ERRO_SALVAR)
            }
          })
          .catch(() => {
            this.showErro(ERRO_SALVAR)
          })
      }
    },
    isBlocoValido() {
      if (this.bloco.descricao.trim().length === 0) {
        this.showErro(PREENCHA_CAMPOS)
        return false
      }

      if (this.bloco.quantidadeAndar <= 0) {
        this.showErro(MIN_ANDAR)
        return false
      }

      return true
    },
    ...mapActions("message", ["showSucesso", "showErro"]),
  },
}
</script>
